import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, Link, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
// hooks
import useLocales from '../../hooks/useLocales';

// ----------------------------------------------------------------------

const LinkStyle = styled(Link)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.text.primary,
  marginRight: theme.spacing(2),
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
  '&:hover': {
    opacity: 0.8,
    textDecoration: 'none',
  },
}));

// ----------------------------------------------------------------------

MenuSimpleDesktop.propTypes = {
  isOffset: PropTypes.bool,
  navConfig: PropTypes.array,
  isHome: PropTypes.bool,
};

export default function MenuSimpleDesktop({ isHome, isOffset, navConfig }) {
  // const { pathname } = useLocation();

  return (
    <Stack direction="row">
      {navConfig.map((link) => (
        <Fragment key={link.title}>
          {isHome && link.path === '/' ? <></> : <MenuDesktopItem item={link} isOffset={isOffset} />}
        </Fragment>
      ))}
    </Stack>
  );
}

// ----------------------------------------------------------------------

IconBullet.propTypes = {
  type: PropTypes.oneOf(['item', 'subheader']),
};

function IconBullet({ type = 'item' }) {
  return (
    <Box sx={{ width: 24, height: 16, display: 'flex', alignItems: 'center' }}>
      <Box
        component="span"
        sx={{
          ml: '2px',
          width: 4,
          height: 4,
          borderRadius: '50%',
          bgcolor: 'currentColor',
          ...(type !== 'item' && { ml: 0, width: 8, height: 2, borderRadius: 2 }),
        }}
      />
    </Box>
  );
}

// ----------------------------------------------------------------------

MenuDesktopItem.propTypes = {
  isOffset: PropTypes.bool,
  item: PropTypes.shape({
    path: PropTypes.string,
    title: PropTypes.string,
  }),
};

function MenuDesktopItem({ item, isOffset }) {
  const { title, path } = item;
  const { translate } = useLocales();

  return (
    <LinkStyle
      to={path}
      component={RouterLink}
      end={path === '/'}
      sx={{
        ...(isOffset && { color: 'text.primary' }),
        '&.active': {
          color: 'primary.main',
        },
      }}
    >
      {translate(title)}
    </LinkStyle>
  );
}
